import React from "react";
import "./AppNotification.scss";
import {MDBBox, MDBContainer, MDBTypography} from "mdbreact";
import BottomNav from "../../component/BottomNav/BottomNav";
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import WalletDataQuery from "../../queries/WalletData";
import AllNotificationsQuery from "../../queries/AllNotificationsQuery";
import Loading from "../../component/Loading";
import moment from "moment";
import {assetUrl} from "../../serviceApi";

const InvestedIcon = assetUrl+"images/Invested-icon.svg";
const PurchasedIcon = assetUrl+"images/Purchased-icon.svg";
const SuccessIcon = assetUrl+"images/Success-icon.svg";
const ClockIcon = assetUrl+"images/clock.svg";

class AppNotification extends React.Component {
	state = {
		notifications: [],
		loading:false
	}
	componentDidMount() {
		this.getNotificationData();
	}

	getIcon = (status) => {
		let tmp_status = status.toLowerCase();
		if (tmp_status === "invested") {
			return InvestedIcon;
		} else if (tmp_status === "purchased") {
			return PurchasedIcon;
		} else if (tmp_status === "success") {
			return SuccessIcon;
		}
	}

	getNotificationData = () => {
		let variables = {

		}
		this.updateLoading(true);
		fetchQuery(environment, AllNotificationsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.userNotification !== null && response.userNotification.edges.length > 0) {
					this.setState({
						notifications: response.userNotification.edges
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					notifications: []
				})
			});
	}
	updateLoading = (action) => {
		this.setState({
			loading: action
		})
	}
    getNotificationDate = (date) => {
		return moment(date).format("DD MMM,YYYY h:mm A");
	}
	render() {
		return (
			<Loading loading={this.state.loading}>
				<div>
				{/*<SubPageHeader title="Notifications" show_action={false}/>*/}
				<TopNavSubpage heading={"Notifications"} notify={false} wallet={false}/>
				<MDBContainer className="notification-component py-2">

					<MDBBox className="notification-list my-2">
						{
							this.state.notifications.map((item, index) => {
								return (
									<>
										<MDBBox className="d-flex align-items-center" key={index}>
											<MDBBox className="icon-section mr-3">
												<img src={this.getIcon(item.node.category)} alt="icon" className="img-fluid"/>
											</MDBBox>
											<MDBBox>
												<MDBTypography tag="p"
												               className={"notification-status mb-1"}>{item.node.category}</MDBTypography>
												<MDBTypography tag="p"
												               className={"notification-message mb-1"}>{item.node.content}</MDBTypography>
												<MDBBox className="d-flex align-items-center">
													<img src={ClockIcon} alt="ClockIcon" className="img-fluid mr-1"/>
													<MDBTypography tag="p"
													               className={"notification-time mb-0"}>{this.getNotificationDate(item.node.created)}</MDBTypography>
												</MDBBox>
											</MDBBox>
										</MDBBox>
										<hr/>
									</>
								);
							})
						}
					</MDBBox>
					<br/>
					<br/>
					<br/>
					<br/>
					<MDBBox className="bottom-navbar">
						<BottomNav/>
					</MDBBox>
				</MDBContainer>
			</div>
			</Loading>

		);
	}
}

export default AppNotification;
